module.exports = __webpack_public_path__ + "static/media/ann-win.e95403ca.png";